module.exports = __webpack_public_path__ + "img/icon-caja.92f1357a.svg";